import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CheckIns } from '@/components/check-ins.tsx'
import { CheckOuts } from '@/components/check-outs.tsx'
import { HotelPendingRequests } from '@/components/hotel-pending-requests'
import { useClientSearch } from '@/shared/hooks/use-client-search'
import { ClientSearchModal } from '@/shared/ui/client-search-modal'
import { Tabs, TabsContent } from '@/shared/ui/tabs.tsx'
import { HotelNotificationBanner, useHotelNotificationStore } from '@/widgets/HotelNotificationBanner'
import { HotelReservationsCalendarWidget } from '@/widgets/HotelReservationsCalendar'
import { HotelReservation } from '@monorepo/functions/src/types/reservations'

import { ActiveReservations, Header, TabNavigation } from './components'
import { useReservationModal } from './components/ReservationModalContext'

export default function HotelManagementPage() {
    console.log('HotelManagementPage')
    const [searchParams, setSearchParams] = useSearchParams()
    const { openReservationModal } = useReservationModal()
    const { notifications, dismissNotification } = useHotelNotificationStore()
    const [bookingType, setBookingType] = useState<'hotel' | 'budget' | null>(null)

    const activeTab = searchParams.get('tab') || 'active'

    const { isOpen, handleOpen, handleClose, handleClientSelect, redirectPath, requirePetSelection } = useClientSearch({
        onClientSelect: clientId => {
            if (bookingType === 'hotel') {
                window.location.href = `/booking?userId=${clientId}`
            } else if (bookingType === 'budget') {
                window.location.href = `/booking?userId=${clientId}&type=budget`
            }
        },
        redirectPath: bookingType === 'budget' ? '/booking?type=budget' : '/booking',
        requirePetSelection: false,
    })

    const handleTabChange = (value: string) => {
        setSearchParams(new URLSearchParams({ tab: value }))
    }

    const handleViewReservation = (reservation: HotelReservation) => {
        openReservationModal(reservation)
    }

    const handleNewBudget = () => {
        setBookingType('budget')
        handleOpen()
    }

    const handleNewReservation = () => {
        setBookingType('hotel')
        handleOpen()
    }

    return (
        <div>
            <div className='container mx-auto space-y-6 p-6'>
                <Header onNewBudget={handleNewBudget} onNewReservation={handleNewReservation} />

                {isOpen && (
                    <ClientSearchModal
                        isOpen={isOpen}
                        onClose={handleClose}
                        onClientSelect={handleClientSelect}
                        redirectPath={redirectPath}
                        requirePetSelection={requirePetSelection}
                    />
                )}

                <HotelNotificationBanner notifications={notifications} onDismiss={dismissNotification} />

                <Tabs value={activeTab} onValueChange={handleTabChange} className='space-y-4'>
                    <TabNavigation />

                    <TabsContent value='pending'>
                        <HotelPendingRequests />
                    </TabsContent>

                    <TabsContent value='active'>
                        <ActiveReservations onViewReservation={handleViewReservation} />
                    </TabsContent>

                    <TabsContent value='check-ins'>
                        <CheckIns onViewReservation={handleViewReservation} />
                    </TabsContent>

                    <TabsContent value='check-outs'>
                        <CheckOuts />
                    </TabsContent>

                    <TabsContent value='calendar'>
                        <HotelReservationsCalendarWidget />
                    </TabsContent>
                </Tabs>
            </div>
        </div>
    )
}
